import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ css }: any) => ({
  section: css``,
  body: css`
    padding-top: 0;
  `,
}));

export const useHeaderStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
